// extracted by mini-css-extract-plugin
module.exports = {"accordionSummary":"accordionSummary_axn1q","results":"results_r0o65","actions":"actions_5ytqe"};